import type { PropsWithChildren } from "react";

export default function FormErrorMessage({ children }: PropsWithChildren) {
	return <p className="text-center text-sm text-red-500">{children}</p>;
}
